import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { endpoints } from "./endpoints";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'any' })
export class customerService {

    constructor(private httpClient: HttpClient, private endPoints: endpoints) { }

    customerUpdate(body: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.updateCustomer, body);
    }

    getCustomerProfile(languageCode: any): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getCustomerProfile + '?language_code=' + languageCode);
    }

    getBookings(): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getBookings);
    }

    getTravellerList(): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getTravellerList);
    }

    getTraveller(id: string, language_Code: string): Observable<any> {
        return this.httpClient.get(environment.API_URL + this.endPoints.getTraveller + '?traveller_id=' + id + '&language_code=' + language_Code);
    }

    createTraveller(body: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.createTraveller, body);
    }

    updateTraveller(body: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.updateTraveller, body);
    }

    deleteTraveller(id: string, language_Code: string): Observable<any> {
        return this.httpClient.delete(environment.API_URL + this.endPoints.deleteTraveller + '/' + id + '?language_code=' + language_Code);
    }

    changePassword(body: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.changePassword, body);
    }

    customerLogout(body: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.customerLogout, body);
    }

    closeCustomerAccount(body: any): Observable<any> {
        return this.httpClient.post(environment.API_URL + this.endPoints.closeCustomerAccount, body);
    }

}
